<!--
  Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->
<h1 class="title">Manage Vehicle Attributes</h1>
<span class="header-spacing"></span>
<button mat-raised-button color="primary" class="edit-button"
        [disabled]="existNonCompliantProgramCode"
        (click)="resetFilter()">
  Reset Filters
</button>
<fab-loading-spinner color="primary" *ngIf="showSpinner" id="loading-spinner"></fab-loading-spinner>
<div *ngIf="existNonCompliantProgramCode">
  <p>Run Manage Architecture Deviances tool before changing Vehicle Attributes</p>
</div>
<div [hidden]="existNonCompliantProgramCode">
  <div>
    <mat-form-field appearance="fill"
                    (click)="resetText(regions)">
      <mat-label>Regions</mat-label>
      <input type="text" id="regions-input"
             [placeholder]="ALL"
             matInput
             [formControl]="regions.model"
             [matAutocomplete]="autoRegions"/>
      <mat-autocomplete #autoRegions="matAutocomplete" (optionSelected)="onChangeRegion()">
        <mat-option *ngFor="let region of regions.filteredOptions | async"
                    [value]="region">{{region}}</mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <span class="spacing"></span>

    <mat-form-field appearance="fill"
                    (click)="resetText(subRegions)">
      <mat-label>Sub Regions</mat-label>
      <input type="text" id="subregion-input"
             [placeholder]="ALL"
             matInput
             [formControl]="subRegions.model"
             [matAutocomplete]="autoSubRegion"/>
      <mat-autocomplete #autoSubRegion="matAutocomplete" (optionSelected)="onChangeSubRegion()">
        <mat-option *ngFor="let subRegion of subRegions.filteredOptions | async"
                    [value]="subRegion">{{subRegion}}</mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <span class="spacing"></span>

    <mat-form-field appearance="fill"
                    (click)="resetText(planningMarkets)">
      <mat-label>Planning Market</mat-label>
      <input type="text" id="planning-market-input"
             [placeholder]="ALL"
             matInput
             [formControl]="planningMarkets.model"
             [matAutocomplete]="autoPlanningMarkets"/>
      <mat-autocomplete #autoPlanningMarkets="matAutocomplete" (optionSelected)="onChangePlanningMarket()">
        <mat-option *ngFor="let planningMarket of planningMarkets.filteredOptions | async"
                    [value]="planningMarket">{{planningMarket}}</mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <span class="spacing"></span>

    <mat-form-field appearance="fill"
                    (click)="resetText(architectures)">
      <mat-label>Architectures</mat-label>
      <input type="text" id="architecture-input"
             [placeholder]="ALL"
             matInput
             [formControl]="architectures.model"
             [matAutocomplete]="autoArchitectures"/>
      <mat-autocomplete #autoArchitectures="matAutocomplete" (optionSelected)="onChangeArchitecture()">
        <mat-option *ngFor="let architecture of architectures.filteredOptions | async"
                    [value]="architecture">{{architecture}}</mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <button mat-raised-button color="primary" class="edit-button"
            [disabled]="architectures.selectedOptions === ALL || architectures.selectedOptions === '%'"
            (click)="openDialog('Architectures', architectures.selectedOptions,
           architectures.key, architectures.maxLength)">
      Edit
    </button>
  </div>

  <div>
    <mat-form-field appearance="fill"
                    (click)="resetText(marketDivisions)">
      <mat-label>Market Divisions</mat-label>
      <input type="text" id="market-division-input"
             [placeholder]="ALL"
             matInput
             [formControl]="marketDivisions.model"
             [matAutocomplete]="autoMarketDivisions"/>
      <mat-autocomplete #autoMarketDivisions="matAutocomplete" (optionSelected)="onChangeMarketDivision()">
        <mat-option *ngFor="let marketDivision of marketDivisions.filteredOptions | async"
                    [value]="marketDivision">{{marketDivision}}</mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <span class="spacing"></span>

    <mat-form-field appearance="fill"
                    (click)="resetText(brands)">
      <mat-label>Brands</mat-label>
      <input type="text" id="brand-input"
             [placeholder]="ALL"
             matInput
             [formControl]="brands.model"
             [matAutocomplete]="autoBrands"/>
      <mat-autocomplete #autoBrands="matAutocomplete" (optionSelected)="onChangeBrand()">
        <mat-option *ngFor="let brand of brands.filteredOptions | async"
                    [value]="brand">{{brand}}</mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <button mat-raised-button color="primary" class="edit-button"
            [disabled]="brands.selectedOptions === ALL || brands.selectedOptions === '%'"
            (click)="openDialog('Brands', brands.selectedOptions,
           brands.key, brands.maxLength)">
      Edit
    </button>

    <mat-form-field appearance="fill"
                    (click)="resetText(localBrands)">
      <mat-label>Local Brands</mat-label>
      <input type="text" id="local-brand-input"
             [placeholder]="ALL"
             matInput
             [formControl]="localBrands.model"
             [matAutocomplete]="autoLocalBrand"/>
      <mat-autocomplete #autoLocalBrand="matAutocomplete" (optionSelected)="onChangeLocalBrand()">
        <mat-option *ngFor="let localBrand of localBrands.filteredOptions | async"
                    [value]="localBrand">{{localBrand}}</mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <button mat-raised-button color="primary" class="edit-button"
            [disabled]="localBrands.selectedOptions === ALL || localBrands.selectedOptions === '%'"
            (click)="openDialog('Local brands', localBrands.selectedOptions,
           localBrands.key, localBrands.maxLength)">
      Edit
    </button>

    <mat-form-field appearance="fill"
                    (click)="resetText(programCodes)">
      <mat-label>Program Codes</mat-label>
      <input type="text" id="program-code-input"
             [placeholder]="ALL"
             matInput
             [formControl]="programCodes.model"
             [matAutocomplete]="autoProgramCode"/>
      <mat-autocomplete #autoProgramCode="matAutocomplete" (optionSelected)="onChangeProgramCode()">
        <mat-option *ngFor="let programCode of programCodes.filteredOptions | async"
                    [value]="programCode">{{programCode}}</mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <button mat-raised-button color="primary" class="edit-button"
            [disabled]="programCodes.selectedOptions === ALL || programCodes.selectedOptions === '%'"
            (click)="openDialog('Program Codes', programCodes.selectedOptions,
           programCodes.key, programCodes.maxLength)">
      Edit
    </button>
  </div>

  <div>

    <mat-form-field appearance="fill"
                    (click)="resetText(styleCodes)">
      <mat-label> Style Codes</mat-label>
      <input type="text" id="style-code-input"
             [placeholder]="ALL"
             matInput
             [formControl]="styleCodes.model"
             [matAutocomplete]="autoStyleCodes"/>
      <mat-autocomplete #autoStyleCodes="matAutocomplete" (optionSelected)="onChangeStyleCode()">
        <mat-option *ngFor="let styleCode of styleCodes.filteredOptions | async"
                    [value]="styleCode">{{styleCode}}</mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <button mat-raised-button color="primary" class="edit-button"
            [disabled]="styleCodes.selectedOptions === ALL || styleCodes.selectedOptions === '%'"
            (click)="openDialog('Style Codes', styleCodes.selectedOptions,
           styleCodes.key, styleCodes.maxLength)">
      Edit
    </button>

    <mat-form-field appearance="fill"
                    (click)="resetText(bodyStyles)">
      <mat-label>Body Styles</mat-label>
      <input type="text" id="bodystyle-input"
             [placeholder]="ALL"
             matInput
             [formControl]="bodyStyles.model"
             [matAutocomplete]="autoBodyStyles"/>
      <mat-autocomplete #autoBodyStyles="matAutocomplete" (optionSelected)="onChangeBodyStyle()">
        <mat-option *ngFor="let bodyStyle of bodyStyles.filteredOptions | async"
                    [value]="bodyStyle">{{bodyStyle}}</mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <button mat-raised-button color="primary" class="edit-button"
            [disabled]="bodyStyles.selectedOptions === ALL || bodyStyles.selectedOptions === '%'"
            (click)="openDialog('Body Styles', bodyStyles.selectedOptions,
           bodyStyles.key, bodyStyles.maxLength)">
      Edit
    </button>

    <mat-form-field appearance="fill"
                    (click)="resetText(vehicleTypes)">
      <mat-label>Vehicle Type</mat-label>
      <input type="text" id="vehicle-type-input"
             [placeholder]="ALL"
             matInput
             [formControl]="vehicleTypes.model"
             [matAutocomplete]="autoVehicleTypes"/>
      <mat-autocomplete #autoVehicleTypes="matAutocomplete" (optionSelected)="onChangeVehicleType()">
        <mat-option *ngFor="let vehicleType of vehicleTypes.filteredOptions | async"
                    [value]="vehicleType">{{vehicleType}}</mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <button mat-raised-button color="primary" class="edit-button"
            [disabled]="vehicleTypes.selectedOptions === ALL || vehicleTypes.selectedOptions === '%'"
            (click)="openDialog('Vehicle Types', vehicleTypes.selectedOptions,
           vehicleTypes.key, vehicleTypes.maxLength)">
      Edit
    </button>

  </div>
</div>
